export { default, type PartnersSectionProps } from './PartnersSection';
